import type { Quote, QuoteFormat } from '../api/types';
import { formatCOP, formatDateTime, formatQty } from '../utils/format';

export function QuoteDocument({ quote, format }: { quote: Quote; format: QuoteFormat }) {
  return (
    <article className="quote-doc quote-print-area">
      <header className="quote-doc-header">
        {format.logoData ? <img src={format.logoData} alt={`Logotipo de ${format.companyName}`} className="quote-doc-logo" /> : <div />}
        <div className="quote-doc-issuer">
          <strong>{format.companyName}</strong>
          <span>{format.branchName}</span>
        </div>
      </header>

      <div className="quote-doc-title">
        <h2>Cotización {quote.code}</h2>
        <span>{formatDateTime(quote.date)}</span>
      </div>

      <section className="quote-doc-client">
        <div>
          <small>Cliente</small>
          <strong>{quote.clientName}</strong>
        </div>
        {quote.clientDocument && (
          <div>
            <small>Documento</small>
            <span>{quote.clientDocument}</span>
          </div>
        )}
        {quote.clientAddress && (
          <div>
            <small>Dirección</small>
            <span>{quote.clientAddress}</span>
          </div>
        )}
        {quote.clientPhone && (
          <div>
            <small>Teléfono</small>
            <span>{quote.clientPhone}</span>
          </div>
        )}
      </section>

      <table className="quote-doc-table">
        <thead>
          <tr>
            <th>Artículo</th>
            <th>Descripción</th>
            <th className="text-right">Cant.</th>
            <th className="text-right">Valor unitario</th>
            <th className="text-right">Valor total</th>
          </tr>
        </thead>
        <tbody>
          {(quote.items ?? []).map((item) => (
            <tr key={item.id}>
              <td>
                {item.nameSnapshot}
                <br />
                <small>{item.codeSnapshot}</small>
              </td>
              <td>{item.description || '—'}</td>
              <td className="text-right">{formatQty(item.quantity)}</td>
              <td className="text-right">{formatCOP(item.unitCost)}</td>
              <td className="text-right">{formatCOP(item.totalCost)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4} className="text-right">
              <strong>Total</strong>
            </td>
            <td className="text-right">
              <strong>{formatCOP(quote.totalCost)}</strong>
            </td>
          </tr>
        </tfoot>
      </table>

      {quote.notes && <p className="quote-doc-notes">Observaciones: {quote.notes}</p>}
      {format.footerText && <p className="quote-doc-footer">{format.footerText}</p>}
      {quote.user && <p className="quote-doc-seller">Atendido por: {quote.user.fullName}</p>}
    </article>
  );
}

export function quoteShareText(quote: Quote, format: QuoteFormat) {
  const lines = (quote.items ?? []).map((i) => `- ${i.nameSnapshot} x ${formatQty(i.quantity)}: ${formatCOP(i.totalCost)}`);
  return [
    `${format.companyName} - ${format.branchName}`,
    `Cotización ${quote.code}`,
    `Cliente: ${quote.clientName}`,
    '',
    ...lines,
    '',
    `Total: ${formatCOP(quote.totalCost)}`,
    format.footerText ?? '',
  ]
    .join('\n')
    .trim();
}
